import { useHistory } from 'react-router-dom';

import classnames from 'classnames';

import { downloadDocument } from 'helpers/document';
import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

import { TYPES } from 'config/document';

import { ReactComponent as DownloadSVG } from 'icons/arrow-down-tray.svg';

import { ReactComponent as DocumentSVG } from 'icons/sd-document.svg';
import { ReactComponent as PGRecordingSVG } from 'icons/sd-pg-recording.svg';
import { ReactComponent as ConsentFormSVG } from 'icons/sd-consent-form.svg';
import { ReactComponent as DAPSVG } from 'icons/sd-dap.svg';
import { ReactComponent as FDSSVG } from 'icons/sd-fds.svg';
import { ReactComponent as PGReportSVG } from 'icons/sd-pg-report.svg';
import { ReactComponent as SleepQQSVG } from 'icons/sd-sleep-qq.svg';

const DocumentCardNew = ({ data, date, userType }) => {
  const history = useHistory();
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const onDownload = async (doc) => {
    await downloadDocument(doc.id, doc);
  };

  const { id, type, isGenerated, signatureStatus, user } = data;
  let createdBy;
  let icon;

  if (user) {
    const role = user.role;
    createdBy = [user[role].firstName, user[role].lastName]
      .filter(Boolean)
      .join(' ');
  }

  const articleClasses = classnames('grid-cards', {
    pointer: userType !== 'non-sleep',
  });

  switch (type) {
    case 'pg-recording':
    case 'psg-recording':
      icon = <PGRecordingSVG />;
      break;
    case 'consent-form':
      icon = <ConsentFormSVG />;
      break;
    case 'sleep-qq':
      icon = <SleepQQSVG />;
      break;
    case 'pg-report':
    case 'psg-report':
      icon = <PGReportSVG />;
      break;
    case 'fds':
    case 'payment-receipt':
    case 'mutual-insurance-card':
      icon = <FDSSVG />;
      break;
    case 'dap':
    case 'prescription':
    case 'referral-letter':
      icon = <DAPSVG />;
      break;
    case 'other':
      icon = <DocumentSVG />;
      break;
    default:
      icon = <DocumentSVG />;
      break;
  }

  const DesktopView = (
    <article
      className={articleClasses}
      onClick={() =>
        userType === 'non-sleep' ? null : history.push(`/documents/${id}`)
      }
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 6' }}>
        <div className="mr6">{icon}</div>
        <div className="apps-card-meta ">
          <div className="apps-card-app-title-new">
            {TYPES.find((t) => t.id === type)?.label}
          </div>

          {createdBy && (
            <div className="flex flex-row" style={{ gap: '6px' }}>
              <div>
                <p className="apps-card-app-desc-new">Created by:</p>
              </div>
              <div className="flex flex-column">
                <p className="apps-card-app-desc-new">{createdBy}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="apps-card-right-new" style={{ gridColumn: 'span 3' }}>
        {isGenerated && (
          <div className="mr5 flex">
            <span className="th-badge th-badge-gray">Generated</span>
          </div>
        )}
        {signatureStatus === 'signed' && (
          <div className="mr5 flex">
            <span className="th-badge th-badge-green">{signatureStatus}</span>
          </div>
        )}
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 1', justifySelf: 'end' }}
      >
        <DownloadSVG
          data-rh="Download"
          className="h6 w6 pointer"
          onClick={(e) => {
            e.stopPropagation();
            onDownload(data);
          }}
        />
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
    </article>
  );

  const MobileView = (
    <article
      className={articleClasses}
      onClick={() =>
        userType === 'non-sleep' ? null : history.push(`/documents/${id}`)
      }
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
        <div className="apps-card-meta ">
          <div className="apps-card-app-title-new">
            {TYPES.find((t) => t.id === type)?.label}
          </div>

          {createdBy && (
            <div className="flex flex-row" style={{ gap: '6px' }}>
              <div>
                <p className="apps-card-app-desc-new">Created by:</p>
              </div>
              <div className="flex flex-column">
                <p className="apps-card-app-desc-new">{createdBy}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 6', gap: '8px' }}
      >
        {isGenerated && (
          <div className="mr5 flex">
            <span className="th-badge th-badge-gray">Generated</span>
          </div>
        )}
        {signatureStatus === 'signed' && (
          <div className="mr5 flex">
            <span className="th-badge th-badge-green">{signatureStatus}</span>
          </div>
        )}
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 6', justifySelf: 'end' }}
      >
        <DownloadSVG
          data-rh="Download"
          className="h6 w6 pointer"
          onClick={(e) => {
            e.stopPropagation();
            onDownload(data);
          }}
        />
      </div>
    </article>
  );

  return isMobile ? MobileView : DesktopView;
};

export default DocumentCardNew;
